/* tslint:disable */

/* eslint-disable */
// @ts-nocheck

/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 18
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/implementation/web)
 */
import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production';

export const ApiKey: Record<Environment, string> = {
  production: '8b9c866c9e5c8c78f3610455b0f0be3e',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '18',
    branch: 'main',
    source: 'web',
    versionId: '8ceeb30b-22cf-49c0-a9b5-4fb670bcce45',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface ApplicationsScreenExportFileDownloadProperties {
  /**
   * Size of  downloaded file in bytes
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  fileSize?: number;
  wuid?: string;
}

export interface ApplicationsScreenFilterAppliedProperties {
  filter_chosenMerchantsCount?: any;
  filter_chosenStoresCount?: any;
  filter_period?: any;
  filter_statuses?: any;
  wuid?: string;
}

export interface ApplicationsScreenShownProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  merchantsCount?: number;
  wuid?: string;
}

export interface ApplicationsScreenTapExportProperties {
  wuid?: string;
}

export interface DashboardScreenFilterAppliedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  filter_chosenMerchantsCount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  filter_chosenStoresCount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  filter_period?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  filter_statuses?: string[];
  wuid?: string;
}

export interface DashboardScreenShownProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  merchantsCount?: number;
  wuid?: string;
}

export interface MpAuthOtpErrorProperties {
  application_id?: string;
  person_id?: string;
  phone?: string;
  role?: string;
  wuid?: string;
}

export interface MpAuthOtpResendClickProperties {
  application_id?: string;
  person_id?: string;
  phone?: string;
  role?: string;
  wuid?: string;
}

export interface MpAuthOtpScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  phone?: string;
  role?: string;
  wuid?: string;
}

export interface MpAuthOtpScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  phone?: string;
  role?: string;
  wuid?: string;
}

export interface MpAuthPhoneScreenGetCodeClickProperties {
  application_id?: string;
  person_id?: string;
  phone?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAboutBusinessScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentInfoScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentInfoScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentInfoScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentListDeleteAgentClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentListEditAgentClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentListScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentListScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentListScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentsStartScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentsStartScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAgentsStartScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAirtableScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAirtableScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaAirtableScreenOpenClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBankingDetailsScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBankingDetailsScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBankingDetailsScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBankingProofOfAccountUploadedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDetailsScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDetailsScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDetailsScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDocBirUploadedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDocDtiUploadedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDocMayorsPermitUploadedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDocOtherUploadedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDocumentsScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDocumentsScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessDocumentsScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessStartScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessTypeCorporationSelectProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessTypePartnershipSelectProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessTypeScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessTypeScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessTypeScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaBusinessTypeSoleProprietorSelectProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaCreateApplicationFailedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaDeleteAgentDialogCancelClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaDeleteAgentDialogConfirmClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaDeleteStoreDialogCancelClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaDeleteStoreDialogConfirmClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaFinishApplicationClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaMainOfficeAddressScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaMainOfficeAddressScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaMainOfficeAddressScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreAddressScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreAddressScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreAddressScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreInfoScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreInfoScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreInfoScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreMapScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreMapScreenCannotFindClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreMapScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStoreMapScreenConfirmClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStorePhotoUploadedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStorePhotosScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStorePhotosScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOfflineStorePhotosScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOnlineStoreInfoScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOnlineStoreInfoScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaOnlineStoreInfoScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaRegisteredBusinessAddressScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaRegisteredBusinessAddressScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaRegisteredBusinessAddressScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaReviewEditAgentsClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaReviewEditBankDetailsClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaReviewEditBusinessDetailsClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaReviewEditBusinessDocumentsClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaReviewEditMainOfficeAddressClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaReviewEditRegisteredBusinessAddressClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaReviewEditStoresClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaReviewSubmitApplicationClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStartApplicationClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStoreListScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStoreListScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStoreListScreenDeleteStoreClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStoreListScreenEditStoreClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStoreListScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStoresStartScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStoresStartScreenCloseClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaStoresStartScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaSubmitApplicationFailedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpPaUpdateApplicationFailedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileAddressScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileAddressScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileBasicInfoScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileIdDocumentUploadedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileSelfieScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileSelfieScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileSelfieUploadedProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileStartScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileUploadIdScreenBackClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface MpProfileUploadIdScreenNextClickProperties {
  application_id?: string;
  person_id?: string;
  role?: string;
  wuid?: string;
}

export interface PaymentsScreenExportFileDownloadProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  fileSize?: number;
  wuid?: string;
}

export interface PaymentsScreenFilterAppliedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  filter_chosenMerchantsCount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  filter_chosenStoresCount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  filter_period?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  filter_statuses?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  filter_term?: string;
  wuid?: string;
}

export interface PaymentsScreenShownProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  merchantsCount?: number;
  wuid?: string;
}

export interface PaymentsScreenTapExportProperties {
  wuid?: string;
}

export class ApplicationsScreenExportFileDownload implements BaseEvent {
  event_type = 'applications_screen_export_file_download';

  constructor(
    public event_properties?: ApplicationsScreenExportFileDownloadProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationsScreenFilterApplied implements BaseEvent {
  event_type = 'applications_screen_filter_applied';

  constructor(
    public event_properties?: ApplicationsScreenFilterAppliedProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationsScreenShown implements BaseEvent {
  event_type = 'applications_screen_shown';

  constructor(public event_properties?: ApplicationsScreenShownProperties) {
    this.event_properties = event_properties;
  }
}

export class ApplicationsScreenTapExport implements BaseEvent {
  event_type = 'applications_screen_tap_export';

  constructor(public event_properties?: ApplicationsScreenTapExportProperties) {
    this.event_properties = event_properties;
  }
}

export class DashboardScreenFilterApplied implements BaseEvent {
  event_type = 'dashboard_screen_filter_applied';

  constructor(
    public event_properties?: DashboardScreenFilterAppliedProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class DashboardScreenShown implements BaseEvent {
  event_type = 'dashboard_screen_shown';

  constructor(public event_properties?: DashboardScreenShownProperties) {
    this.event_properties = event_properties;
  }
}

export class MpAuthOtpError implements BaseEvent {
  event_type = 'mp_auth_otp_error';

  constructor(public event_properties?: MpAuthOtpErrorProperties) {
    this.event_properties = event_properties;
  }
}

export class MpAuthOtpResendClick implements BaseEvent {
  event_type = 'mp_auth_otp_resend_click';

  constructor(public event_properties?: MpAuthOtpResendClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpAuthOtpScreenBackClick implements BaseEvent {
  event_type = 'mp_auth_otp_screen_back_click';

  constructor(public event_properties?: MpAuthOtpScreenBackClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpAuthOtpScreenNextClick implements BaseEvent {
  event_type = 'mp_auth_otp_screen_next_click';

  constructor(public event_properties?: MpAuthOtpScreenNextClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpAuthPhoneScreenGetCodeClick implements BaseEvent {
  event_type = 'mp_auth_phone_screen_get_code_click';

  constructor(
    public event_properties?: MpAuthPhoneScreenGetCodeClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAboutBusinessScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_about_business_screen_close_click';

  constructor(
    public event_properties?: MpPaAboutBusinessScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentInfoScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_agent_info_screen_back_click';

  constructor(
    public event_properties?: MpPaAgentInfoScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentInfoScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_agent_info_screen_close_click';

  constructor(
    public event_properties?: MpPaAgentInfoScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentInfoScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_agent_info_screen_next_click';

  constructor(
    public event_properties?: MpPaAgentInfoScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentListDeleteAgentClick implements BaseEvent {
  event_type = 'mp_pa_agent_list_delete_agent_click';

  constructor(
    public event_properties?: MpPaAgentListDeleteAgentClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentListEditAgentClick implements BaseEvent {
  event_type = 'mp_pa_agent_list_edit_agent_click';

  constructor(public event_properties?: MpPaAgentListEditAgentClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentListScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_agent_list_screen_back_click';

  constructor(
    public event_properties?: MpPaAgentListScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentListScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_agent_list_screen_close_click';

  constructor(
    public event_properties?: MpPaAgentListScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentListScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_agent_list_screen_next_click';

  constructor(
    public event_properties?: MpPaAgentListScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentsStartScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_agents_start_screen_back_click';

  constructor(
    public event_properties?: MpPaAgentsStartScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentsStartScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_agents_start_screen_close_click';

  constructor(
    public event_properties?: MpPaAgentsStartScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAgentsStartScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_agents_start_screen_next_click';

  constructor(
    public event_properties?: MpPaAgentsStartScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAirtableScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_airtable_screen_back_click';

  constructor(public event_properties?: MpPaAirtableScreenBackClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaAirtableScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_airtable_screen_close_click';

  constructor(
    public event_properties?: MpPaAirtableScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaAirtableScreenOpenClick implements BaseEvent {
  event_type = 'mp_pa_airtable_screen_open_click';

  constructor(public event_properties?: MpPaAirtableScreenOpenClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaBankingDetailsScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_banking_details_screen_back_click';

  constructor(
    public event_properties?: MpPaBankingDetailsScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBankingDetailsScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_banking_details_screen_close_click';

  constructor(
    public event_properties?: MpPaBankingDetailsScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBankingDetailsScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_banking_details_screen_next_click';

  constructor(
    public event_properties?: MpPaBankingDetailsScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBankingProofOfAccountUploaded implements BaseEvent {
  event_type = 'mp_pa_banking_proof_of_account_uploaded';

  constructor(
    public event_properties?: MpPaBankingProofOfAccountUploadedProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDetailsScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_business_details_screen_back_click';

  constructor(
    public event_properties?: MpPaBusinessDetailsScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDetailsScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_business_details_screen_close_click';

  constructor(
    public event_properties?: MpPaBusinessDetailsScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDetailsScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_business_details_screen_next_click';

  constructor(
    public event_properties?: MpPaBusinessDetailsScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDocBirUploaded implements BaseEvent {
  event_type = 'mp_pa_business_doc_bir_uploaded';

  constructor(public event_properties?: MpPaBusinessDocBirUploadedProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDocDtiUploaded implements BaseEvent {
  event_type = 'mp_pa_business_doc_dti_uploaded';

  constructor(public event_properties?: MpPaBusinessDocDtiUploadedProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDocMayorsPermitUploaded implements BaseEvent {
  event_type = 'mp_pa_business_doc_mayors_permit_uploaded';

  constructor(
    public event_properties?: MpPaBusinessDocMayorsPermitUploadedProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDocOtherUploaded implements BaseEvent {
  event_type = 'mp_pa_business_doc_other_uploaded';

  constructor(
    public event_properties?: MpPaBusinessDocOtherUploadedProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDocumentsScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_business_documents_screen_back_click';

  constructor(
    public event_properties?: MpPaBusinessDocumentsScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDocumentsScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_business_documents_screen_close_click';

  constructor(
    public event_properties?: MpPaBusinessDocumentsScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessDocumentsScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_business_documents_screen_next_click';

  constructor(
    public event_properties?: MpPaBusinessDocumentsScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessStartScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_business_start_screen_next_click';

  constructor(
    public event_properties?: MpPaBusinessStartScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessTypeCorporationSelect implements BaseEvent {
  event_type = 'mp_pa_business_type_corporation_select';

  constructor(
    public event_properties?: MpPaBusinessTypeCorporationSelectProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessTypePartnershipSelect implements BaseEvent {
  event_type = 'mp_pa_business_type_partnership_select';

  constructor(
    public event_properties?: MpPaBusinessTypePartnershipSelectProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessTypeScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_business_type_screen_back_click';

  constructor(
    public event_properties?: MpPaBusinessTypeScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessTypeScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_business_type_screen_close_click';

  constructor(
    public event_properties?: MpPaBusinessTypeScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessTypeScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_business_type_screen_next_click';

  constructor(
    public event_properties?: MpPaBusinessTypeScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaBusinessTypeSoleProprietorSelect implements BaseEvent {
  event_type = 'mp_pa_business_type_sole_proprietor_select';

  constructor(
    public event_properties?: MpPaBusinessTypeSoleProprietorSelectProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaCreateApplicationFailed implements BaseEvent {
  event_type = 'mp_pa_create_application_failed';

  constructor(public event_properties?: MpPaCreateApplicationFailedProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaDeleteAgentDialogCancelClick implements BaseEvent {
  event_type = 'mp_pa_delete_agent_dialog_cancel_click';

  constructor(
    public event_properties?: MpPaDeleteAgentDialogCancelClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaDeleteAgentDialogConfirmClick implements BaseEvent {
  event_type = 'mp_pa_delete_agent_dialog_confirm_click';

  constructor(
    public event_properties?: MpPaDeleteAgentDialogConfirmClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaDeleteStoreDialogCancelClick implements BaseEvent {
  event_type = 'mp_pa_delete_store_dialog_cancel_click';

  constructor(
    public event_properties?: MpPaDeleteStoreDialogCancelClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaDeleteStoreDialogConfirmClick implements BaseEvent {
  event_type = 'mp_pa_delete_store_dialog_confirm_click';

  constructor(
    public event_properties?: MpPaDeleteStoreDialogConfirmClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaFinishApplicationClick implements BaseEvent {
  event_type = 'mp_pa_finish_application_click';

  constructor(public event_properties?: MpPaFinishApplicationClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaMainOfficeAddressScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_main_office_address_screen_back_click';

  constructor(
    public event_properties?: MpPaMainOfficeAddressScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaMainOfficeAddressScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_main_office_address_screen_close_click';

  constructor(
    public event_properties?: MpPaMainOfficeAddressScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaMainOfficeAddressScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_main_office_address_screen_next_click';

  constructor(
    public event_properties?: MpPaMainOfficeAddressScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreAddressScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_address_screen_back_click';

  constructor(
    public event_properties?: MpPaOfflineStoreAddressScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreAddressScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_address_screen_close_click';

  constructor(
    public event_properties?: MpPaOfflineStoreAddressScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreAddressScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_address_screen_next_click';

  constructor(
    public event_properties?: MpPaOfflineStoreAddressScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreInfoScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_info_screen_back_click';

  constructor(
    public event_properties?: MpPaOfflineStoreInfoScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreInfoScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_info_screen_close_click';

  constructor(
    public event_properties?: MpPaOfflineStoreInfoScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreInfoScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_info_screen_next_click';

  constructor(
    public event_properties?: MpPaOfflineStoreInfoScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreMapScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_map_screen_back_click';

  constructor(
    public event_properties?: MpPaOfflineStoreMapScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreMapScreenCannotFindClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_map_screen_cannot_find_click';

  constructor(
    public event_properties?: MpPaOfflineStoreMapScreenCannotFindClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreMapScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_map_screen_close_click';

  constructor(
    public event_properties?: MpPaOfflineStoreMapScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStoreMapScreenConfirmClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_map_screen_confirm_click';

  constructor(
    public event_properties?: MpPaOfflineStoreMapScreenConfirmClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStorePhotoUploaded implements BaseEvent {
  event_type = 'mp_pa_offline_store_photo_uploaded';

  constructor(
    public event_properties?: MpPaOfflineStorePhotoUploadedProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStorePhotosScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_photos_screen_back_click';

  constructor(
    public event_properties?: MpPaOfflineStorePhotosScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStorePhotosScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_photos_screen_close_click';

  constructor(
    public event_properties?: MpPaOfflineStorePhotosScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOfflineStorePhotosScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_offline_store_photos_screen_next_click';

  constructor(
    public event_properties?: MpPaOfflineStorePhotosScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOnlineStoreInfoScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_online_store_info_screen_back_click';

  constructor(
    public event_properties?: MpPaOnlineStoreInfoScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOnlineStoreInfoScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_online_store_info_screen_close_click';

  constructor(
    public event_properties?: MpPaOnlineStoreInfoScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaOnlineStoreInfoScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_online_store_info_screen_next_click';

  constructor(
    public event_properties?: MpPaOnlineStoreInfoScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaRegisteredBusinessAddressScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_registered_business_address_screen_back_click';

  constructor(
    public event_properties?: MpPaRegisteredBusinessAddressScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaRegisteredBusinessAddressScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_registered_business_address_screen_close_click';

  constructor(
    public event_properties?: MpPaRegisteredBusinessAddressScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaRegisteredBusinessAddressScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_registered_business_address_screen_next_click';

  constructor(
    public event_properties?: MpPaRegisteredBusinessAddressScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaReviewEditAgentsClick implements BaseEvent {
  event_type = 'mp_pa_review_edit_agents_click';

  constructor(public event_properties?: MpPaReviewEditAgentsClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaReviewEditBankDetailsClick implements BaseEvent {
  event_type = 'mp_pa_review_edit_bank_details_click';

  constructor(
    public event_properties?: MpPaReviewEditBankDetailsClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaReviewEditBusinessDetailsClick implements BaseEvent {
  event_type = 'mp_pa_review_edit_business_details_click';

  constructor(
    public event_properties?: MpPaReviewEditBusinessDetailsClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaReviewEditBusinessDocumentsClick implements BaseEvent {
  event_type = 'mp_pa_review_edit_business_documents_click';

  constructor(
    public event_properties?: MpPaReviewEditBusinessDocumentsClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaReviewEditMainOfficeAddressClick implements BaseEvent {
  event_type = 'mp_pa_review_edit_main_office_address_click';

  constructor(
    public event_properties?: MpPaReviewEditMainOfficeAddressClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaReviewEditRegisteredBusinessAddressClick implements BaseEvent {
  event_type = 'mp_pa_review_edit_registered_business_address_click';

  constructor(
    public event_properties?: MpPaReviewEditRegisteredBusinessAddressClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaReviewEditStoresClick implements BaseEvent {
  event_type = 'mp_pa_review_edit_stores_click';

  constructor(public event_properties?: MpPaReviewEditStoresClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaReviewSubmitApplicationClick implements BaseEvent {
  event_type = 'mp_pa_review_submit_application_click';

  constructor(
    public event_properties?: MpPaReviewSubmitApplicationClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaStartApplicationClick implements BaseEvent {
  event_type = 'mp_pa_start_application_click';

  constructor(public event_properties?: MpPaStartApplicationClickProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaStoreListScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_store_list_screen_back_click';

  constructor(
    public event_properties?: MpPaStoreListScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaStoreListScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_store_list_screen_close_click';

  constructor(
    public event_properties?: MpPaStoreListScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaStoreListScreenDeleteStoreClick implements BaseEvent {
  event_type = 'mp_pa_store_list_screen_delete_store_click';

  constructor(
    public event_properties?: MpPaStoreListScreenDeleteStoreClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaStoreListScreenEditStoreClick implements BaseEvent {
  event_type = 'mp_pa_store_list_screen_edit_store_click';

  constructor(
    public event_properties?: MpPaStoreListScreenEditStoreClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaStoreListScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_store_list_screen_next_click';

  constructor(
    public event_properties?: MpPaStoreListScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaStoresStartScreenBackClick implements BaseEvent {
  event_type = 'mp_pa_stores_start_screen_back_click';

  constructor(
    public event_properties?: MpPaStoresStartScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaStoresStartScreenCloseClick implements BaseEvent {
  event_type = 'mp_pa_stores_start_screen_close_click';

  constructor(
    public event_properties?: MpPaStoresStartScreenCloseClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaStoresStartScreenNextClick implements BaseEvent {
  event_type = 'mp_pa_stores_start_screen_next_click';

  constructor(
    public event_properties?: MpPaStoresStartScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpPaSubmitApplicationFailed implements BaseEvent {
  event_type = 'mp_pa_submit_application_failed';

  constructor(public event_properties?: MpPaSubmitApplicationFailedProperties) {
    this.event_properties = event_properties;
  }
}

export class MpPaUpdateApplicationFailed implements BaseEvent {
  event_type = 'mp_pa_update_application_failed';

  constructor(public event_properties?: MpPaUpdateApplicationFailedProperties) {
    this.event_properties = event_properties;
  }
}

export class MpProfileAddressScreenBackClick implements BaseEvent {
  event_type = 'mp_profile_address_screen_back_click';

  constructor(
    public event_properties?: MpProfileAddressScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpProfileAddressScreenNextClick implements BaseEvent {
  event_type = 'mp_profile_address_screen_next_click';

  constructor(
    public event_properties?: MpProfileAddressScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpProfileBasicInfoScreenNextClick implements BaseEvent {
  event_type = 'mp_profile_basic_info_screen_next_click';

  constructor(
    public event_properties?: MpProfileBasicInfoScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpProfileIdDocumentUploaded implements BaseEvent {
  event_type = 'mp_profile_id_document_uploaded';

  constructor(public event_properties?: MpProfileIdDocumentUploadedProperties) {
    this.event_properties = event_properties;
  }
}

export class MpProfileSelfieScreenBackClick implements BaseEvent {
  event_type = 'mp_profile_selfie_screen_back_click';

  constructor(
    public event_properties?: MpProfileSelfieScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpProfileSelfieScreenNextClick implements BaseEvent {
  event_type = 'mp_profile_selfie_screen_next_click';

  constructor(
    public event_properties?: MpProfileSelfieScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpProfileSelfieUploaded implements BaseEvent {
  event_type = 'mp_profile_selfie_uploaded';

  constructor(public event_properties?: MpProfileSelfieUploadedProperties) {
    this.event_properties = event_properties;
  }
}

export class MpProfileStartScreenNextClick implements BaseEvent {
  event_type = 'mp_profile_start_screen_next_click';

  constructor(
    public event_properties?: MpProfileStartScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpProfileUploadIdScreenBackClick implements BaseEvent {
  event_type = 'mp_profile_upload_id_screen_back_click';

  constructor(
    public event_properties?: MpProfileUploadIdScreenBackClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class MpProfileUploadIdScreenNextClick implements BaseEvent {
  event_type = 'mp_profile_upload_id_screen_next_click';

  constructor(
    public event_properties?: MpProfileUploadIdScreenNextClickProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PaymentsScreenExportFileDownload implements BaseEvent {
  event_type = 'payments_screen_export_file_download';

  constructor(
    public event_properties?: PaymentsScreenExportFileDownloadProperties
  ) {
    this.event_properties = event_properties;
  }
}

export class PaymentsScreenFilterApplied implements BaseEvent {
  event_type = 'payments_screen_filter_applied';

  constructor(public event_properties?: PaymentsScreenFilterAppliedProperties) {
    this.event_properties = event_properties;
  }
}

export class PaymentsScreenShown implements BaseEvent {
  event_type = 'payments_screen_shown';

  constructor(public event_properties?: PaymentsScreenShownProperties) {
    this.event_properties = event_properties;
  }
}

export class PaymentsScreenTapExport implements BaseEvent {
  event_type = 'payments_screen_tap_export';

  constructor(public event_properties?: PaymentsScreenTapExportProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * applications_screen_export_file_download
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/applications_screen_export_file_download)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. fileSize)
   * @param options Amplitude event options.
   */
  applicationsScreenExportFileDownload(
    properties?: ApplicationsScreenExportFileDownloadProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationsScreenExportFileDownload(properties), options);
  }

  /**
   * applications_screen_filter_applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/applications_screen_filter_applied)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_chosenMerchantsCount)
   * @param options Amplitude event options.
   */
  applicationsScreenFilterApplied(
    properties?: ApplicationsScreenFilterAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationsScreenFilterApplied(properties), options);
  }

  /**
   * applications_screen_shown
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/applications_screen_shown)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. merchantsCount)
   * @param options Amplitude event options.
   */
  applicationsScreenShown(
    properties?: ApplicationsScreenShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationsScreenShown(properties), options);
  }

  /**
   * applications_screen_tap_export
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/applications_screen_tap_export)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wuid)
   * @param options Amplitude event options.
   */
  applicationsScreenTapExport(
    properties?: ApplicationsScreenTapExportProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationsScreenTapExport(properties), options);
  }

  /**
   * dashboard_screen_filter_applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/dashboard_screen_filter_applied)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_chosenMerchantsCount)
   * @param options Amplitude event options.
   */
  dashboardScreenFilterApplied(
    properties?: DashboardScreenFilterAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardScreenFilterApplied(properties), options);
  }

  /**
   * dashboard_screen_shown
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/dashboard_screen_shown)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. merchantsCount)
   * @param options Amplitude event options.
   */
  dashboardScreenShown(
    properties?: DashboardScreenShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardScreenShown(properties), options);
  }

  /**
   * mp_auth_otp_error
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_auth_otp_error)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpAuthOtpError(
    properties?: MpAuthOtpErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpAuthOtpError(properties), options);
  }

  /**
   * mp_auth_otp_resend_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_auth_otp_resend_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpAuthOtpResendClick(
    properties?: MpAuthOtpResendClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpAuthOtpResendClick(properties), options);
  }

  /**
   * mp_auth_otp_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_auth_otp_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpAuthOtpScreenBackClick(
    properties?: MpAuthOtpScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpAuthOtpScreenBackClick(properties), options);
  }

  /**
   * mp_auth_otp_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_auth_otp_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpAuthOtpScreenNextClick(
    properties?: MpAuthOtpScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpAuthOtpScreenNextClick(properties), options);
  }

  /**
   * mp_auth_phone_screen_get_code_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_auth_phone_screen_get_code_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpAuthPhoneScreenGetCodeClick(
    properties?: MpAuthPhoneScreenGetCodeClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpAuthPhoneScreenGetCodeClick(properties), options);
  }

  /**
   * mp_pa_about_business_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_about_business_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAboutBusinessScreenCloseClick(
    properties?: MpPaAboutBusinessScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAboutBusinessScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_agent_info_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agent_info_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentInfoScreenBackClick(
    properties?: MpPaAgentInfoScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentInfoScreenBackClick(properties), options);
  }

  /**
   * mp_pa_agent_info_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agent_info_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentInfoScreenCloseClick(
    properties?: MpPaAgentInfoScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentInfoScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_agent_info_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agent_info_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentInfoScreenNextClick(
    properties?: MpPaAgentInfoScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentInfoScreenNextClick(properties), options);
  }

  /**
   * mp_pa_agent_list_delete_agent_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agent_list_delete_agent_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentListDeleteAgentClick(
    properties?: MpPaAgentListDeleteAgentClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentListDeleteAgentClick(properties), options);
  }

  /**
   * mp_pa_agent_list_edit_agent_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agent_list_edit_agent_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentListEditAgentClick(
    properties?: MpPaAgentListEditAgentClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentListEditAgentClick(properties), options);
  }

  /**
   * mp_pa_agent_list_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agent_list_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentListScreenBackClick(
    properties?: MpPaAgentListScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentListScreenBackClick(properties), options);
  }

  /**
   * mp_pa_agent_list_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agent_list_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentListScreenCloseClick(
    properties?: MpPaAgentListScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentListScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_agent_list_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agent_list_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentListScreenNextClick(
    properties?: MpPaAgentListScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentListScreenNextClick(properties), options);
  }

  /**
   * mp_pa_agents_start_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agents_start_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentsStartScreenBackClick(
    properties?: MpPaAgentsStartScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentsStartScreenBackClick(properties), options);
  }

  /**
   * mp_pa_agents_start_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agents_start_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentsStartScreenCloseClick(
    properties?: MpPaAgentsStartScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentsStartScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_agents_start_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_agents_start_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAgentsStartScreenNextClick(
    properties?: MpPaAgentsStartScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAgentsStartScreenNextClick(properties), options);
  }

  /**
   * mp_pa_airtable_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_airtable_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAirtableScreenBackClick(
    properties?: MpPaAirtableScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAirtableScreenBackClick(properties), options);
  }

  /**
   * mp_pa_airtable_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_airtable_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAirtableScreenCloseClick(
    properties?: MpPaAirtableScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAirtableScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_airtable_screen_open_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_airtable_screen_open_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaAirtableScreenOpenClick(
    properties?: MpPaAirtableScreenOpenClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaAirtableScreenOpenClick(properties), options);
  }

  /**
   * mp_pa_banking_details_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_banking_details_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBankingDetailsScreenBackClick(
    properties?: MpPaBankingDetailsScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBankingDetailsScreenBackClick(properties), options);
  }

  /**
   * mp_pa_banking_details_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_banking_details_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBankingDetailsScreenCloseClick(
    properties?: MpPaBankingDetailsScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBankingDetailsScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_banking_details_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_banking_details_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBankingDetailsScreenNextClick(
    properties?: MpPaBankingDetailsScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBankingDetailsScreenNextClick(properties), options);
  }

  /**
   * mp_pa_banking_proof_of_account_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_banking_proof_of_account_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBankingProofOfAccountUploaded(
    properties?: MpPaBankingProofOfAccountUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBankingProofOfAccountUploaded(properties), options);
  }

  /**
   * mp_pa_business_details_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_details_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDetailsScreenBackClick(
    properties?: MpPaBusinessDetailsScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDetailsScreenBackClick(properties), options);
  }

  /**
   * mp_pa_business_details_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_details_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDetailsScreenCloseClick(
    properties?: MpPaBusinessDetailsScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDetailsScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_business_details_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_details_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDetailsScreenNextClick(
    properties?: MpPaBusinessDetailsScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDetailsScreenNextClick(properties), options);
  }

  /**
   * mp_pa_business_doc_bir_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_doc_bir_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDocBirUploaded(
    properties?: MpPaBusinessDocBirUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDocBirUploaded(properties), options);
  }

  /**
   * mp_pa_business_doc_dti_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_doc_dti_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDocDtiUploaded(
    properties?: MpPaBusinessDocDtiUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDocDtiUploaded(properties), options);
  }

  /**
   * mp_pa_business_doc_mayors_permit_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_doc_mayors_permit_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDocMayorsPermitUploaded(
    properties?: MpPaBusinessDocMayorsPermitUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDocMayorsPermitUploaded(properties), options);
  }

  /**
   * mp_pa_business_doc_other_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_doc_other_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDocOtherUploaded(
    properties?: MpPaBusinessDocOtherUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDocOtherUploaded(properties), options);
  }

  /**
   * mp_pa_business_documents_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_documents_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDocumentsScreenBackClick(
    properties?: MpPaBusinessDocumentsScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDocumentsScreenBackClick(properties), options);
  }

  /**
   * mp_pa_business_documents_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_documents_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDocumentsScreenCloseClick(
    properties?: MpPaBusinessDocumentsScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDocumentsScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_business_documents_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_documents_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessDocumentsScreenNextClick(
    properties?: MpPaBusinessDocumentsScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessDocumentsScreenNextClick(properties), options);
  }

  /**
   * mp_pa_business_start_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_start_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessStartScreenNextClick(
    properties?: MpPaBusinessStartScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessStartScreenNextClick(properties), options);
  }

  /**
   * mp_pa_business_type_corporation_select
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_type_corporation_select)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessTypeCorporationSelect(
    properties?: MpPaBusinessTypeCorporationSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessTypeCorporationSelect(properties), options);
  }

  /**
   * mp_pa_business_type_partnership_select
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_type_partnership_select)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessTypePartnershipSelect(
    properties?: MpPaBusinessTypePartnershipSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessTypePartnershipSelect(properties), options);
  }

  /**
   * mp_pa_business_type_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_type_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessTypeScreenBackClick(
    properties?: MpPaBusinessTypeScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessTypeScreenBackClick(properties), options);
  }

  /**
   * mp_pa_business_type_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_type_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessTypeScreenCloseClick(
    properties?: MpPaBusinessTypeScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessTypeScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_business_type_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_type_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessTypeScreenNextClick(
    properties?: MpPaBusinessTypeScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessTypeScreenNextClick(properties), options);
  }

  /**
   * mp_pa_business_type_sole_proprietor_select
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_business_type_sole_proprietor_select)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaBusinessTypeSoleProprietorSelect(
    properties?: MpPaBusinessTypeSoleProprietorSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaBusinessTypeSoleProprietorSelect(properties), options);
  }

  /**
   * mp_pa_create_application_failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_create_application_failed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaCreateApplicationFailed(
    properties?: MpPaCreateApplicationFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaCreateApplicationFailed(properties), options);
  }

  /**
   * mp_pa_delete_agent_dialog_cancel_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_delete_agent_dialog_cancel_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaDeleteAgentDialogCancelClick(
    properties?: MpPaDeleteAgentDialogCancelClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaDeleteAgentDialogCancelClick(properties), options);
  }

  /**
   * mp_pa_delete_agent_dialog_confirm_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_delete_agent_dialog_confirm_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaDeleteAgentDialogConfirmClick(
    properties?: MpPaDeleteAgentDialogConfirmClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaDeleteAgentDialogConfirmClick(properties), options);
  }

  /**
   * mp_pa_delete_store_dialog_cancel_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_delete_store_dialog_cancel_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaDeleteStoreDialogCancelClick(
    properties?: MpPaDeleteStoreDialogCancelClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaDeleteStoreDialogCancelClick(properties), options);
  }

  /**
   * mp_pa_delete_store_dialog_confirm_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_delete_store_dialog_confirm_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaDeleteStoreDialogConfirmClick(
    properties?: MpPaDeleteStoreDialogConfirmClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaDeleteStoreDialogConfirmClick(properties), options);
  }

  /**
   * mp_pa_finish_application_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_finish_application_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaFinishApplicationClick(
    properties?: MpPaFinishApplicationClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaFinishApplicationClick(properties), options);
  }

  /**
   * mp_pa_main_office_address_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_main_office_address_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaMainOfficeAddressScreenBackClick(
    properties?: MpPaMainOfficeAddressScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaMainOfficeAddressScreenBackClick(properties), options);
  }

  /**
   * mp_pa_main_office_address_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_main_office_address_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaMainOfficeAddressScreenCloseClick(
    properties?: MpPaMainOfficeAddressScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaMainOfficeAddressScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_main_office_address_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_main_office_address_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaMainOfficeAddressScreenNextClick(
    properties?: MpPaMainOfficeAddressScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaMainOfficeAddressScreenNextClick(properties), options);
  }

  /**
   * mp_pa_offline_store_address_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_address_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreAddressScreenBackClick(
    properties?: MpPaOfflineStoreAddressScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreAddressScreenBackClick(properties), options);
  }

  /**
   * mp_pa_offline_store_address_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_address_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreAddressScreenCloseClick(
    properties?: MpPaOfflineStoreAddressScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreAddressScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_offline_store_address_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_address_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreAddressScreenNextClick(
    properties?: MpPaOfflineStoreAddressScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreAddressScreenNextClick(properties), options);
  }

  /**
   * mp_pa_offline_store_info_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_info_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreInfoScreenBackClick(
    properties?: MpPaOfflineStoreInfoScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreInfoScreenBackClick(properties), options);
  }

  /**
   * mp_pa_offline_store_info_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_info_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreInfoScreenCloseClick(
    properties?: MpPaOfflineStoreInfoScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreInfoScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_offline_store_info_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_info_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreInfoScreenNextClick(
    properties?: MpPaOfflineStoreInfoScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreInfoScreenNextClick(properties), options);
  }

  /**
   * mp_pa_offline_store_map_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_map_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreMapScreenBackClick(
    properties?: MpPaOfflineStoreMapScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreMapScreenBackClick(properties), options);
  }

  /**
   * mp_pa_offline_store_map_screen_cannot_find_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_map_screen_cannot_find_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreMapScreenCannotFindClick(
    properties?: MpPaOfflineStoreMapScreenCannotFindClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreMapScreenCannotFindClick(properties), options);
  }

  /**
   * mp_pa_offline_store_map_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_map_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreMapScreenCloseClick(
    properties?: MpPaOfflineStoreMapScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreMapScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_offline_store_map_screen_confirm_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_map_screen_confirm_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStoreMapScreenConfirmClick(
    properties?: MpPaOfflineStoreMapScreenConfirmClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStoreMapScreenConfirmClick(properties), options);
  }

  /**
   * mp_pa_offline_store_photo_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_photo_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStorePhotoUploaded(
    properties?: MpPaOfflineStorePhotoUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStorePhotoUploaded(properties), options);
  }

  /**
   * mp_pa_offline_store_photos_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_photos_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStorePhotosScreenBackClick(
    properties?: MpPaOfflineStorePhotosScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStorePhotosScreenBackClick(properties), options);
  }

  /**
   * mp_pa_offline_store_photos_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_photos_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStorePhotosScreenCloseClick(
    properties?: MpPaOfflineStorePhotosScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStorePhotosScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_offline_store_photos_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_offline_store_photos_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOfflineStorePhotosScreenNextClick(
    properties?: MpPaOfflineStorePhotosScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOfflineStorePhotosScreenNextClick(properties), options);
  }

  /**
   * mp_pa_online_store_info_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_online_store_info_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOnlineStoreInfoScreenBackClick(
    properties?: MpPaOnlineStoreInfoScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOnlineStoreInfoScreenBackClick(properties), options);
  }

  /**
   * mp_pa_online_store_info_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_online_store_info_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOnlineStoreInfoScreenCloseClick(
    properties?: MpPaOnlineStoreInfoScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOnlineStoreInfoScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_online_store_info_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_online_store_info_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaOnlineStoreInfoScreenNextClick(
    properties?: MpPaOnlineStoreInfoScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaOnlineStoreInfoScreenNextClick(properties), options);
  }

  /**
   * mp_pa_registered_business_address_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_registered_business_address_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaRegisteredBusinessAddressScreenBackClick(
    properties?: MpPaRegisteredBusinessAddressScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaRegisteredBusinessAddressScreenBackClick(properties), options);
  }

  /**
   * mp_pa_registered_business_address_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_registered_business_address_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaRegisteredBusinessAddressScreenCloseClick(
    properties?: MpPaRegisteredBusinessAddressScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaRegisteredBusinessAddressScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_registered_business_address_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_registered_business_address_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaRegisteredBusinessAddressScreenNextClick(
    properties?: MpPaRegisteredBusinessAddressScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaRegisteredBusinessAddressScreenNextClick(properties), options);
  }

  /**
   * mp_pa_review_edit_agents_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_review_edit_agents_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaReviewEditAgentsClick(
    properties?: MpPaReviewEditAgentsClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaReviewEditAgentsClick(properties), options);
  }

  /**
   * mp_pa_review_edit_bank_details_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_review_edit_bank_details_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaReviewEditBankDetailsClick(
    properties?: MpPaReviewEditBankDetailsClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaReviewEditBankDetailsClick(properties), options);
  }

  /**
   * mp_pa_review_edit_business_details_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_review_edit_business_details_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaReviewEditBusinessDetailsClick(
    properties?: MpPaReviewEditBusinessDetailsClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaReviewEditBusinessDetailsClick(properties), options);
  }

  /**
   * mp_pa_review_edit_business_documents_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_review_edit_business_documents_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaReviewEditBusinessDocumentsClick(
    properties?: MpPaReviewEditBusinessDocumentsClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaReviewEditBusinessDocumentsClick(properties), options);
  }

  /**
   * mp_pa_review_edit_main_office_address_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_review_edit_main_office_address_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaReviewEditMainOfficeAddressClick(
    properties?: MpPaReviewEditMainOfficeAddressClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaReviewEditMainOfficeAddressClick(properties), options);
  }

  /**
   * mp_pa_review_edit_registered_business_address_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_review_edit_registered_business_address_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaReviewEditRegisteredBusinessAddressClick(
    properties?: MpPaReviewEditRegisteredBusinessAddressClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaReviewEditRegisteredBusinessAddressClick(properties), options);
  }

  /**
   * mp_pa_review_edit_stores_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_review_edit_stores_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaReviewEditStoresClick(
    properties?: MpPaReviewEditStoresClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaReviewEditStoresClick(properties), options);
  }

  /**
   * mp_pa_review_submit_application_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_review_submit_application_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaReviewSubmitApplicationClick(
    properties?: MpPaReviewSubmitApplicationClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaReviewSubmitApplicationClick(properties), options);
  }

  /**
   * mp_pa_start_application_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_start_application_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStartApplicationClick(
    properties?: MpPaStartApplicationClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStartApplicationClick(properties), options);
  }

  /**
   * mp_pa_store_list_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_store_list_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStoreListScreenBackClick(
    properties?: MpPaStoreListScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStoreListScreenBackClick(properties), options);
  }

  /**
   * mp_pa_store_list_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_store_list_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStoreListScreenCloseClick(
    properties?: MpPaStoreListScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStoreListScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_store_list_screen_delete_store_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_store_list_screen_delete_store_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStoreListScreenDeleteStoreClick(
    properties?: MpPaStoreListScreenDeleteStoreClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStoreListScreenDeleteStoreClick(properties), options);
  }

  /**
   * mp_pa_store_list_screen_edit_store_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_store_list_screen_edit_store_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStoreListScreenEditStoreClick(
    properties?: MpPaStoreListScreenEditStoreClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStoreListScreenEditStoreClick(properties), options);
  }

  /**
   * mp_pa_store_list_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_store_list_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStoreListScreenNextClick(
    properties?: MpPaStoreListScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStoreListScreenNextClick(properties), options);
  }

  /**
   * mp_pa_stores_start_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_stores_start_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStoresStartScreenBackClick(
    properties?: MpPaStoresStartScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStoresStartScreenBackClick(properties), options);
  }

  /**
   * mp_pa_stores_start_screen_close_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_stores_start_screen_close_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStoresStartScreenCloseClick(
    properties?: MpPaStoresStartScreenCloseClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStoresStartScreenCloseClick(properties), options);
  }

  /**
   * mp_pa_stores_start_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_stores_start_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaStoresStartScreenNextClick(
    properties?: MpPaStoresStartScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaStoresStartScreenNextClick(properties), options);
  }

  /**
   * mp_pa_submit_application_failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_submit_application_failed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaSubmitApplicationFailed(
    properties?: MpPaSubmitApplicationFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaSubmitApplicationFailed(properties), options);
  }

  /**
   * mp_pa_update_application_failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_pa_update_application_failed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpPaUpdateApplicationFailed(
    properties?: MpPaUpdateApplicationFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpPaUpdateApplicationFailed(properties), options);
  }

  /**
   * mp_profile_address_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_address_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileAddressScreenBackClick(
    properties?: MpProfileAddressScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileAddressScreenBackClick(properties), options);
  }

  /**
   * mp_profile_address_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_address_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileAddressScreenNextClick(
    properties?: MpProfileAddressScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileAddressScreenNextClick(properties), options);
  }

  /**
   * mp_profile_basic_info_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_basic_info_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileBasicInfoScreenNextClick(
    properties?: MpProfileBasicInfoScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileBasicInfoScreenNextClick(properties), options);
  }

  /**
   * mp_profile_id_document_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_id_document_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileIdDocumentUploaded(
    properties?: MpProfileIdDocumentUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileIdDocumentUploaded(properties), options);
  }

  /**
   * mp_profile_selfie_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_selfie_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileSelfieScreenBackClick(
    properties?: MpProfileSelfieScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileSelfieScreenBackClick(properties), options);
  }

  /**
   * mp_profile_selfie_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_selfie_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileSelfieScreenNextClick(
    properties?: MpProfileSelfieScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileSelfieScreenNextClick(properties), options);
  }

  /**
   * mp_profile_selfie_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_selfie_uploaded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileSelfieUploaded(
    properties?: MpProfileSelfieUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileSelfieUploaded(properties), options);
  }

  /**
   * mp_profile_start_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_start_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileStartScreenNextClick(
    properties?: MpProfileStartScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileStartScreenNextClick(properties), options);
  }

  /**
   * mp_profile_upload_id_screen_back_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_upload_id_screen_back_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileUploadIdScreenBackClick(
    properties?: MpProfileUploadIdScreenBackClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileUploadIdScreenBackClick(properties), options);
  }

  /**
   * mp_profile_upload_id_screen_next_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/mp_profile_upload_id_screen_next_click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  mpProfileUploadIdScreenNextClick(
    properties?: MpProfileUploadIdScreenNextClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MpProfileUploadIdScreenNextClick(properties), options);
  }

  /**
   * payments_screen_export_file_download
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/payments_screen_export_file_download)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. fileSize)
   * @param options Amplitude event options.
   */
  paymentsScreenExportFileDownload(
    properties?: PaymentsScreenExportFileDownloadProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentsScreenExportFileDownload(properties), options);
  }

  /**
   * payments_screen_filter_applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/payments_screen_filter_applied)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_chosenMerchantsCount)
   * @param options Amplitude event options.
   */
  paymentsScreenFilterApplied(
    properties?: PaymentsScreenFilterAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentsScreenFilterApplied(properties), options);
  }

  /**
   * payments_screen_shown
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/payments_screen_shown)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. merchantsCount)
   * @param options Amplitude event options.
   */
  paymentsScreenShown(
    properties?: PaymentsScreenShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentsScreenShown(properties), options);
  }

  /**
   * payments_screen_tap_export
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/Merchant%20portal%20QA/events/main/latest/payments_screen_tap_export)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wuid)
   * @param options Amplitude event options.
   */
  paymentsScreenTapExport(
    properties?: PaymentsScreenTapExportProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentsScreenTapExport(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
